export default "__VITE_ASSET__765de292__"